<template>
	<div>
		<div class="text-center" v-if="loading>0">
			<b-icon icon="circle-fill" animation="throb" font-scale="4"></b-icon>
		</div>
		<b-alert show v-else-if="error" variant="danger" class="mb-3">{{error?.error||error}}</b-alert>
		<b-form v-else-if="user" @submit.prevent="saveSettings()">
			<b-overlay :show="saving > 0" variant="dark">
				<b-card class="mb-3">
					<template title>
						<h4 class="card-title">Restreaming <small><b-badge v-if="!$parent.$parent.user.is_pro" variant="warning" style="font-size: .8rem; vertical-align: top; position: relative; top: -10px" to="/account/billing?plan=pro&period=monthly">PRO</b-badge></small></h4>
					</template>
					<fieldset :disabled="!user.is_pro">
						<b-form-row>
							<b-col md="6">
								<b-form-group label="Restreaming service">
									<b-select v-model="user.restreaming_service_id" :options="restreaming_services" value-field="id" text-field="name"></b-select>
								</b-form-group>
							</b-col>
							<b-col md="6">
								<b-form-group label="Protocol" v-slot="{ ariaDescribedby }">
									<b-form-radio-group
										v-model="user.restreaming_proto"
										:options="restreamingProtocols"
										:aria-describedby="ariaDescribedby"
										name="restreaming_proto"
										id="restreaming_proto"
									></b-form-radio-group>
								</b-form-group>
							</b-col>
						</b-form-row>
						<b-form-group label="SRT URL" v-if="restreamingData && user.restreaming_proto == 'srt'">
							<b-input-group>
								<b-form-input id="srt-url" placeholder="srt://" readonly :value="restreamingData.srtUrl" @focus="$event.target.select()"/>
								<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(restreamingData.srtUrl, 'Copied SRT URL to clipboard', $event)"><b-icon icon="clipboard"/> Copy</b-button></b-input-group-append>
							</b-input-group>
						</b-form-group>
						<b-form-group label="RTMP URL" v-if="restreamingData && user.restreaming_proto == 'rtmp'">
							<b-input-group>
								<b-form-input id="rtmp-url" placeholder="rtmp://" readonly :value="restreamingData.rtmpUrl" @focus="$event.target.select()"/>
								<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(restreamingData.rtmpUrl, 'Copied RTMP URL to clipboard', $event)"><b-icon icon="clipboard"/> Copy</b-button></b-input-group-append>
							</b-input-group>
						</b-form-group>
						<b-form-group label="RTMPS URL" v-if="restreamingData && user.restreaming_proto == 'rtmps'">
							<b-input-group>
								<b-form-input id="rtmp-url" placeholder="rtmps://" readonly :value="restreamingData.rtmpsUrl" @focus="$event.target.select()"/>
								<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(restreamingData.rtmpsUrl, 'Copied RTMPS URL to clipboard', $event)"><b-icon icon="clipboard"/> Copy</b-button></b-input-group-append>
							</b-input-group>
						</b-form-group>
						<b-form-group label="Stream key" v-if="restreamingData && user.restreaming_proto.startsWith('rtmp')">
							<b-input-group>
								<b-form-input id="rtmp-key" readonly :type="showRtmpKey?'text':'password'" :value="restreamingData.rtmpKey" @focus="$event.target.select()"/>
								<b-input-group-append><b-button variant="outline-info" @click="showRtmpKey=!showRtmpKey"><b-icon icon="eye"></b-icon> Show</b-button></b-input-group-append>
								<b-input-group-append><b-button type="button" variant="info" @click.capture.prevent.stop="copyAndToast(restreamingData.rtmpKey, 'Copied stream key to clipboard', $event)"><b-icon icon="clipboard"/> Copy</b-button></b-input-group-append>
							</b-input-group>
						</b-form-group>
						<b-form-row class="mt-3">
							<b-col>
								<b-button variant="warning" @click="$refs.streamResetModal.show()" size="sm">Reset stream</b-button>
								<b-spinner v-show="loading>0" small label="Loading" class="float-right"></b-spinner>
							</b-col>
						</b-form-row>
					</fieldset>
					<b-alert :show="saveError" variant="danger" class="mb-3">{{saveError&&(saveError.saveError||saveError.toString())}}</b-alert>
					<div class="text-center mt-3">
						<b-button variant="primary" type="submit">Save settings</b-button>
					</div>
				</b-card>
			</b-overlay>
			<stream-reset-modal ref="streamResetModal" @saved="loadUserData()" />
		</b-form>
		<div v-else>NO USER</div>
	</div>
</template>

<script>
import StreamResetModal from '@/components/User/Modal/StreamReset.vue';

export default {
	data() { return {
		loading: 0,
		error: null,
		saving: 0,
		saveError: null,
		user: null,
		restreamingProtocols: [
			{ value: 'rtmp', text: 'RTMP' },
			{ value: 'srt', text: 'SRT' },
		],
		showRtmpKey: false,
		restreaming_services: null,
		restreamingData: null,
	}},
	components: {
		StreamResetModal,
	},
	async mounted() {
		try {
			this.error = null;
			this.saveError = null;
			this.saving = 0;
			this.loading++;
			await this.load();
		} catch(e) {
			console.error(e);
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	methods: {
		async load() {
			[
				this.restreaming_services,
				this.user,
			] = await Promise.all([
				this.$api.get('restreaming/services'),
				{ ...this.$parent.$parent.user },
			]);
		},
		async saveSettings() {
			try {
				this.saveError = null;
				this.saving++;
				await this.$api.post('userData', {
					restreaming_service_id: this.user.restreaming_service_id,
					restreaming_proto: this.user.restreaming_proto,
				});
				await this.$parent.$parent.loadUserData();
				await this.load();
			} catch(e) {
				console.error(e);
				this.saveError = e;
			} finally {
				this.saving--;
			}
		},
	},
};
</script>
